<template>
    <div class="loaderCont loaderOrdersList" v-show="this.isLoading">
        <div class="loader"></div>
    </div>
    <div class="HistoryTable Table" v-if="this.ShowGrid">
        <TableFilter
            :ShowFilters = true
            :FilterMap="this.FilterMap"
            @filtra="this.Search($event)" 
            @moreFilter="this.GetData($event)"
        />
        <table width="100%" border="0" cellspacing="0" cellpadding="0" v-show="!this.isLoading">
            <tbody>
                <tr class="TableHead">
                    <th scope="col" class="align-left HTOrderCode" >{{ this.risorse['idDoc'] }}</th>
                    <th scope="col" class="align-left">{{ this.risorse['ragSoc'] }}</th>
                    <th scope="col" class="align-left">{{ this.risorse['codiceCliente'] }}</th>
                    <th scope="col" class="align-left">{{ this.risorse['descrDest'] }}</th>
                    <th scope="col" class="align-left HTShippingAddress">{{ this.risorse['Indirizzo'] }}</th>
                    <th scope="col" class="align-left HTOrderDate">{{ this.risorse['dtDoc'] }}</th>
                    <th scope="col" class="align-left">{{ this.risorse['NumeroDocumento'] }}</th>
                    <th scope="col" class="align-left">{{ this.risorse['tipoDoc'] }}</th>
                    <th scope="col" class="ShortLink">&nbsp;</th>
                </tr>
                <tr class="TableRow" v-for="fattura in this.fatture" :key="fattura.IdDocumento">
                    <td><small>{{ this.risorse['dtDoc'] }}</small><a  class="myLink" @click="goToDetails(fattura)">{{ fattura?.IdDocumento }}</a></td>
                    <td><small>{{ this.risorse['dtDoc'] }}</small><span>{{ fattura?.Nome }}</span></td>
                    <td><small>{{ this.risorse['dtDoc'] }}</small><span>{{ fattura?.CodiceGest }}</span></td>
                    <td><small>{{ this.risorse['dtDoc'] }}</small><span>{{ fattura?.DescrizioneDestinazione }}</span></td>
                    <td><small>{{ this.risorse['dtDoc'] }}</small><span>{{ fattura?.Indirizzo }}</span></td>
                    <td><small>{{ this.risorse['dtDoc'] }}</small><span>{{ this.formatDateNoOre(fattura?.DataDocumento) }}</span></td>
                    <td class="CenteredText"><small>{{ this.risorse['numRata'] }}</small><span>{{ fattura?.NumeroDocumento }}</span></td>
                    <td><small>{{ this.risorse['impRata'] }}</small>{{ fattura?.TipoDocumento }}</td>
                    <td class="HTAddToBasket">
                        <small>{{ this.risorse["ProdottiNonDisponibili"] }}</small>
                        <div class="Button Small CustomColor"><a href="javascript:void(0)" @click="this.goToDetails(fattura)">{{ this.risorse["dettaglio"] }}</a></div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div v-else class="Container">
        <div class="Box">
            <div class="Frame Deadlines">
                <p class="centralElem">{{ this.risorse['noDocumentsMsg'] }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import{risorseMixin,dateMixin} from '@/mixin.js';
import DocumentiService from '@/services/documenti.service.js';
import TableFilter from "@/components/TableFilter.vue";

export default {
    name: 'FattureContainer',
    mixins:[risorseMixin,dateMixin],
    components:{
        TableFilter
    },
    data(){
        return{
            ShowGrid: false,
            fatture: [],
            isLoading: false,
            searchTimeout: 500,
            FilterMap:{
                Cap: false,
                Prov: false,
                DestTxt: true,
                DtDocum: true,
                TpDocum: true,
                NumRata: false,
                Import: false,
                TotOrdine: false
            }
        }
    },
    mounted: function(){
        this.GetData();
    },
    props:{
        ShowFilter: Boolean,
    },
    methods:{
        Search:function(ev){
            if(this.searchTimeout != null){
                clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = setTimeout(() => this.GetData(ev), 500);
        },
        GetData: function(ev){
            this.isLoading = true;
            DocumentiService.getFatture(
                    this.$store.getters.getLingua, 
                    this.$store.getters.getToken,
                    ev
                ).then(
                data => {
                    if(data){
                        this.fatture = data;
                        this.ShowGrid = true;
                    }else{
                        this.ShowGrid = false;
                    }
                    this.isLoading = false;
                }
            );
        },
        goToDetails: function(fattura){
            this.$store.commit("setTestaFattura",fattura);
            this.$router.push({name: 'SchedaFattura', params: {idDoc: fattura?.IdDocumento}});
        }
    }
}
</script>
<style>
.centralElem{
    text-align: center;
}

.align-right{
    text-align: left !important;
}

.myLink{
    cursor: pointer;
    text-decoration: none !important;
    font-weight: bold;
}
</style>
